"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function resolveAriaProperty(componentName, htmlProperty, reactProperty, props) {
    if ((props === null || props === void 0 ? void 0 : props.hasOwnProperty(htmlProperty)) && (props === null || props === void 0 ? void 0 : props.hasOwnProperty(reactProperty))) {
        console.warn(`Accessibility: Component '${componentName}', id: '${props.id}' provided both ${htmlProperty} and ${reactProperty}. ${htmlProperty} was used. Please remove the duplicate property.`);
        return props[htmlProperty];
    }
    else if (props === null || props === void 0 ? void 0 : props.hasOwnProperty(reactProperty)) {
        return props[reactProperty];
    }
    else {
        return props[htmlProperty];
    }
}
exports.default = resolveAriaProperty;
//# sourceMappingURL=resolveAriaProperty.js.map